import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ReportsServiceProvider } from '../../api/reports'

const ReportsService = ReportsServiceProvider()
const name = 'bulkReportsDownloadAllPDF'

export default (campaignId) => (asyncAction(
  name,
  ReportsService.bulkReportsDownloadAllPDF,
  { campaignId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/reports/bulkReportsDownloadAllPDF.js